import React from 'react'
import { isFlagOn } from 'utils/featureFlags'
import {
  CourseManagerGetter,
  CourseManagerType,
} from 'layers/content/v2/Hocs/CourseManagerGetter'
import { CurriculumCourseManagerGetter } from 'layers/content/v3/Hocs/CurriculumCourseManagerGetter'
import { CURRICULUM_CONTENT_FLAG } from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'

export { CourseManagerType, CURRICULUM_CONTENT_FLAG }

/**
 * Flag-switched HOC factory. Returns a component that checks the flag at
 * render time, delegating to v3 `CurriculumCourseManagerGetter` when on or
 * the original v2 `CourseManagerGetter` when off.
 *
 * Drop-in replacement for `CourseManagerGetter` — same signature.
 *
 * Defaults to the route/content migration flag, but callers can provide
 * `flagSubscriptions` when a surface has its own coordinated rollout.
 */
export function FlaggedCourseManagerGetter(Component, options = {}) {
  const {
    flagSubscriptions = [CURRICULUM_CONTENT_FLAG],
    ...courseManagerOptions
  } = options
  const CurriculumWrapped = CurriculumCourseManagerGetter(
    Component,
    courseManagerOptions,
  )
  const LegacyWrapped = CourseManagerGetter(Component, courseManagerOptions)

  function FlaggedComponent(props) {
    if (isFlagOn(flagSubscriptions)) {
      return <CurriculumWrapped {...props} />
    }
    return <LegacyWrapped {...props} />
  }

  FlaggedComponent.displayName = `FlaggedCourseManagerGetter(${Component.displayName ||
    Component.name ||
    'Component'})`

  return FlaggedComponent
}
